'use client';

import {YandexBannerAd} from '@shared/Ads/Yandex/Banner/YaBanner';
import {useEnvConfig} from '@web-catalog/env';

import useMediaQueryMatch from '@utils/hooks/useMediaQueryMatch';
import {useGetCurrentAppPackageName} from '@web-catalog/hooks';
import {useOmicronClientFlag} from '@web-catalog/hooks/omicron';

import {useGetVkId} from '@web-catalog/store/auth';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

export const RightSidebarAd = ({
  className,
  minWidthToShow,
}: {
  className: string;
  minWidthToShow: number;
}) => {
  const enabled = useOmicronClientFlag('WEB_YANDEX_AD_RIGHT_SIDEBAR_ENABLED');
  const {YANDEX_ADS_RIGHT_SIDEBAR_BANNER_ID} = useEnvConfig();
  const breakpointMatch = useMediaQueryMatch(
    `(min-width: ${minWidthToShow}px)`,
  );
  const adFoxConfig = useOmicronClientFlag('ADFOX_CONFIG');
  const getPackageName = useGetCurrentAppPackageName();
  const getVkId = useGetVkId();

  if (!enabled || !breakpointMatch) {
    return null;
  }

  return (
    <YandexBannerAd
      blockId={YANDEX_ADS_RIGHT_SIDEBAR_BANNER_ID}
      bannerContainerClassName={className}
      adType="sd_banner_side"
      placement="right_sidebar"
      adFoxConfig={adFoxConfig}
      emitYmEvent={emitYmEvent}
      logTmrEvent={logTmrEvent}
      packageName={getPackageName()}
      vkId={getVkId()}
    />
  );
};
